import api from './api';

// Reader side of the dashboard changelog (spec 2026-10-16 §3). Every signed-in
// dashboard user may call these; only published notes come back.
const resource = 'ReleaseNote/';

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

export const getBySlug = async (slug) => {
  return await api.get(resource + 'Get?slug=' + encodeURIComponent(slug));
};

export const tags = async () => {
  return await api.get(resource + 'Tags');
};

const releaseNoteApi = { list, getBySlug, tags };

export default releaseNoteApi;
